import api from './api';

export const feesAPI = {
  getStudentFees: (studentId) => api.get(`/fees/student-fees/${studentId}`),
  getFeeStructures: (params = {}) => api.get(`/fees/fee-structures`, { params }),
  getFeeTypes: () => api.get('/fees/fee-types'),

  addFeeStructure: (feeStructureData) => api.post('/fees/add-fee-structure', feeStructureData),
  updateFeeStructure: (id, feeStructureData) => api.put(`/fees/update-fee-structure/${id}`, feeStructureData),
  deleteFeeStructure: (id) => api.delete(`/fees/delete-fee-structure/${id}`),

  payFee: (paymentData) => api.post('/fees/pay', paymentData),
  getPaymentHistory: (studentFeeId) => api.get(`/fees/payment-history/${studentFeeId}`),
  getFeePayments: (params) => api.get('/fees/get-fee-payments', { params }),

  getReceiptData: (paymentHistoryId) => api.get(`/fees/receipt-data/${paymentHistoryId}`),
}; 